import React, { Component } from "react";
import { InputGroup, Input, InputGroupAddon } from "reactstrap";
import GenericDatePicker from "./GenericDatePicker";
import { formatValueLabel } from "../utils/normalizeDateHelpers";

class GenericInputDate extends Component {
    state = {
        label: "",
        showPanel: false,
    };

    componentDidMount() {
        if (!this.props.haveInitialValue && this.props.value) {
            this.updateLabelFromValue(this.props.value);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.updateLabelFromValue(this.props.value);
        }
    }

    updateLabelFromValue = (value) => {
        this.setState({ label: formatValueLabel(value, this.props.isCompare) });
    };

    handleChange = (value) => {
        this.updateLabelFromValue(value);
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    handlePanelToggle = () => {
        this.setState({ showPanel: !this.state.showPanel });
    };

    render() {
        const { showPanel } = this.state;
        const { disableMaxDate, isCompare, haveInitialValue } = this.props;

        return (
            <InputGroup className="hdv-force-hight">
                <Input
                    value={this.state.label}
                    placeholder="Selecione o período"
                />

                <InputGroupAddon addonType="append">
                    <GenericDatePicker
                        value={this.props.value}
                        onChange={this.handleChange}
                        emitOnMount={haveInitialValue}
                        showLabel={false}
                        onToggle={this.handlePanelToggle}
                        onApply={this.handlePanelToggle}
                        toggleText={showPanel ? "Fechar Calendário" : "Exibir Calendário"}
                        datepickerStyle={{ minHeight: "100%" }}
                        toggleClass="btn btn-primary"
                        toggleStyle={{ minHeight: "100%", backgroundColor: showPanel ? "#dc3545" : '' }}
                        panelStyle={{ top: "48px", right: "1px" }}
                        disableMaxDate={disableMaxDate}
                        isCompare={isCompare}
                    />
                </InputGroupAddon>
            </InputGroup>
        );
    }
}

export default GenericInputDate;